import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { RouteMatch } from 'modules/types';
import { ERoute } from 'enums/route.enum';
import { Button, Row, Col, Typography } from 'antd';
import styled from 'styled-components';
import { FormWrapper, device } from 'GlobalStyles';
import LoginBackgroundSource from 'assets/images/banners/login.webp';
import TenantSource_DN from 'assets/images/logos/dn.png';
import TenantSource_LG from 'assets/images/logos/lg.svg';
import LogoSource from 'assets/images/logos/logo.svg';

const { Title, Text } = Typography;

const KaitusLogoImage = styled.img`
  width: 150px;
  margin-right: 50px;
  cursor: pointer;

  @media screen and ${device.md} {
    width: 133px;
    margin-right: 20px;
  }
`;

export const LogoImage = (source: string) => {
  return <KaitusLogoImage alt='logo' src={source} />;
};

const Welcome = () => {
  const onClickStart = () => {
    window.location.href = `/kaitus/${tenant_id}/assessment`;
  };

  const baseUrl = ERoute.KaitusWelcome;
  const match = useRouteMatch(baseUrl);
  const { tenant_id } = (match?.params as RouteMatch) || {};

  if (tenant_id === 'lg') {
    return (
      <Row style={{ maxWidth: '1440px', margin: '0 auto' }}>
        <Col xs={0} sm={0} md={0} lg={12} xl={12}>
          <img alt='' src={LoginBackgroundSource} style={{ width: '100%', height: '100%' }} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <FormWrapper style={{ maxWidth: '600px' }}>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Row>
              <Col className='logo-image'>{LogoImage(LogoSource)}</Col>
              <Col className='logo-image'>{LogoImage(TenantSource_LG)}</Col>
            </Row>
            <br />
            <br />
            <br />
            <Title level={2}>Assessment 안내사항</Title>
            <Text style={{ marginTop: '30px', marginBottom: '20px', display: 'inline-block' }}>
              미래사업가 여러분, 안녕하세요.
            </Text>
            <br />
            <Text style={{ marginBottom: '20px', display: 'inline-block' }}>
              [미래사업가 Essential] 프로그램을 마치며, 그동안 열심히 학습한 '고객 관점의 전략적 사고'에 대한
              여러분의 발전된 역량을 측정하기 위해 Post-Assessment를 준비 하였습니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              테스트 시작 버튼을 누르기 전에 아래 가이드를 충분히 숙지하시고 시작해주시기 바랍니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              시작-종료 시점의 Assessment 결과 분석은 개인별 결과 리포트로 발송드릴 예정입니다. 미래사업가로의
              성장에 많은 도움이 되길 바랍니다.
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>[Assessment 환경 준비]</Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * Assessment에 응시하는 동안 방해받지 않는 시간과 공간을 확보해주시기를 권장드립니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              * Assessment는 PC에서 최적화되어 있으며, Mobile 기기에서는 응시가 되지 않습니다. (핸드폰, 패드
              불가)
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>[Assessment 운영 방식]</Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * Assessment는 총 20개의 문항으로 구성되어 있으며, 제한 시간은 60분 입니다.
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * '테스트 시작' 버튼을 누른 후에는 시간을 멈출 수가 없습니다.
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * 다음/이전 문제로 이동 전, 반드시 "선택된 답안 저장"을 눌러주세요. 누르지 않을 경우 '오답'
              처리됩니다.
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * 60분이 경과되면 자동 제출이 되며, 60분 경과 전 '테스트 완료' 버튼 클릭 시 제출됩니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              * 한번 제출을 하고 나면 다시 로그인을 할 수 없습니다.
            </Text>
            <br />
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>[Assessment 사용 관련]</Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * Assessment 시스템 사용 방법은 운영진에서 메일로 송부드린 'Assessment Guide'를 참고해주세요.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              * 시스템 관련 도움이 필요하시면 Help Desk로 연락바랍니다. (운영시간: 06시~24시)
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              #1. '미래사업가 Essential' 슬랙의 'Help Desk' 채널에서 DM을 보내주세요. → 수신처:
              (CS운영진_윤상문)
            </Text>
            <Text style={{ marginBottom: '60px', display: 'inline-block' }}>
              #2. 슬랙이 원활하지 않으시면 메일을 주셔도 됩니다. → 수신처: yun.sangmoon@bigstepedu.com
            </Text>
            <Button type='primary' htmlType='submit' size='large' onClick={onClickStart}>
              테스트 시작
            </Button>
          </FormWrapper>
        </Col>
      </Row>
    );
  } else if (tenant_id === 'dn') {
    return (
      <Row style={{ maxWidth: '1440px', margin: '0 auto' }}>
        <Col xs={0} sm={0} md={0} lg={12} xl={12}>
          <img alt='' src={LoginBackgroundSource} style={{ width: '100%', height: '100%' }} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <FormWrapper style={{ maxWidth: '600px' }}>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Row>
              <Col className='logo-image'>{LogoImage(LogoSource)}</Col>
              <Col style={{ marginTop: '3px' }} className='logo-image'>
                {LogoImage(TenantSource_DN)}
              </Col>
            </Row>
            <br />
            <br />
            <br />
            <Title level={2}>Assessment 안내사항</Title>
            <Text style={{ marginTop: '30px', marginBottom: '20px', display: 'inline-block' }}>
              DN Solutions 여러분, 안녕하세요.
            </Text>
            <br />
            <Text style={{ marginBottom: '20px', display: 'inline-block' }}>
              [S.T.A.R] 과정을 마치며, 그동안 열심히 학습한 ‘전략적 사고‘에 대한 여러분의 발전된 역량을
              측정하기 위해 Post-Assessment를 준비 하였습니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              테스트 시작 버튼을 누르기 전에 아래 가이드를 충분히 숙지하시고 시작해주시기 바랍니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              시작-종료 시점의 Assessment 결과 분석은 개인별 결과 리포트로 발송드릴 예정입니다. 여러분의
              성장에 많은 도움이 되길 바랍니다.
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>[Assessment 환경 준비]</Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * Assessment에 응시하는 동안 방해받지 않는 시간과 공간을 확보해주시기를 권장드립니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              * Assessment는 PC에서 최적화되어 있으며, Mobile 기기에서는 응시가 되지 않습니다. (핸드폰, 패드
              불가)
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>[Assessment 운영 방식]</Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * Assessment는 총 20개의 문항으로 구성되어 있으며, 제한 시간은 60분 입니다.
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * '테스트 시작' 버튼을 누른 후에는 시간을 멈출 수가 없습니다.
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * 다음/이전 문제로 이동 전, 반드시 "선택된 답안 저장"을 눌러주세요. 누르지 않을 경우 '오답'
              처리됩니다.
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * 60분이 경과되면 자동 제출이 되며, 60분 경과 전 '테스트 완료' 버튼 클릭 시 제출됩니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              * 한번 제출을 하고 나면 다시 로그인을 할 수 없습니다.
            </Text>
            <br />
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>[Assessment 사용 관련]</Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              * Assessment 시스템 사용 방법은 운영진에서 메일로 송부드린 'Assessment Guide'를 참고해주세요.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
              * 시스템 관련 도움이 필요하시면 Help Desk로 연락바랍니다. (운영시간: 06시~24시)
            </Text>
            <Text style={{ marginBottom: '0px', display: 'inline-block' }}>
              #1. 수신처: yun.sangmoon@bigstepedu.com
            </Text>
            <br />
            <Text style={{ marginBottom: '60px', display: 'inline-block' }}>
              #2. 수신처: moon.heesung@bigstepedu.com
            </Text>
            <br />
            <br />
            <br />
            <Button type='primary' htmlType='submit' size='large' onClick={onClickStart}>
              테스트 시작
            </Button>
          </FormWrapper>
        </Col>
      </Row>
    );
  } else {
    return <div></div>;
  }
};

export default Welcome;
